import { render, staticRenderFns } from "./SuccessState.vue?vue&type=template&id=120fc6dc&lang=pug"
import script from "./SuccessState.vue?vue&type=script&lang=ts"
export * from "./SuccessState.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports